import { FormControl } from '@angular/forms';
import { AutomatedFuelData } from './automated-fuel-data.model';

export class AutomatedFuelDataForm {
  automatedFuelOut: FormControl;
  automatedFuelOff: FormControl;
  automatedFuelOn: FormControl;
  automatedFuelIn: FormControl;
  automatedFuelBurn: FormControl;

  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(automatedData?: AutomatedFuelData) {
    if (automatedData) {
      this.automatedFuelOut = new FormControl(automatedData.automatedFuelOut);
      this.automatedFuelOff = new FormControl(automatedData.automatedFuelOff);
      this.automatedFuelOn = new FormControl(automatedData.automatedFuelOn);
      this.automatedFuelIn = new FormControl(automatedData.automatedFuelIn);
      this.automatedFuelBurn = new FormControl(automatedData.automatedFuelBurn);
    }
  }
}
